import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Table, Input, Select, Tooltip, Spin } from "antd";
import ButtonField from "../../common/htmlComponents/ButtonField";
import { Collapse } from "antd";
import { getRequest, patchRequest, postRequest } from "../../axios";
import { authUserData } from "../../utils/Helper";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";

const { Panel } = Collapse;

const CityWiseView = ({ response, uomList }) => {
  const [siteName, setSiteName] = useState([]);
  const navigate = useNavigate();
  const { Option } = Select;
  const [pincodeList, setPincodeList] = useState([]);
  const CompanyID = authUserData()?.company ? authUserData()?.company : null;
  const [btnLoading, setBtnLoading] = useState(false);
  const [btnLoading2, setBtnLoading2] = useState(false);
  const [view, setView] = useState(true);
  const { t } = useTranslation();
  const { id } = useParams();
  const [res, setRes] = useState([]);
  const { responseId } = useParams();
  const [disabled, setDisabled] = useState(true);
  const [tableData, setTableData] = useState([]);
  const [rfqMaterialDetailsID, setRfqMaterialDetailsID] = useState(false);
  const [stateWBS, setStateWBS] = useState([]);
  const initialState = {
    company: CompanyID,
    category_tree: id,
    total_amount: null,
    purchase_requisition_details: [],
  };
  const [state, setState] = useState([]);
  const [rfqIDD, setRfqIDD] = useState([]);
  const [masterId, setMasterId] = useState(null);
  const [cityLength, setCityLength] = useState(1);
  const [apiLoading, setapiLoading] = useState(false);
  const [selectedVendors, setSelectedVendors] = useState([]);
  const [oldResponse, setOldResponse] = useState([]);
  const memoizedPincodeList = useMemo(() => uomList || [], [uomList]);
  const getSubCategory = async () => {
    const length = response?.pr_city_wise_by_pr_number[0]?.city_wise_pr?.length;
    setCityLength(length);
  };
  
  useEffect(() => {
    setapiLoading(true);
    if (response.pr_city_wise_by_pr_number !== null) {
      getSubCategory();
    }
    if (siteName.length === 0) {
      getSiteName();
      setPincodeList(uomList);
    }
    setapiLoading(false);
  }, [response, uomList]);

const updateTableData = (state) => {
  setapiLoading(true);
  if (!Array.isArray(state)) {
    return;
  }

  let rfqPresent = null;

  const uniqueMasterIds = new Set();

  state?.forEach((city) => {
    city.city_wise_pr?.forEach((cityDetail) => {
      cityDetail.site_wise_details?.forEach((site) => {
        site.material_wise_details?.forEach((material) => {
          if (material.purchase_requisition_master_id) {
            uniqueMasterIds.add(material.purchase_requisition_master_id);
          }
        });
      });
    });
  });

  const uniqueMasterIdsBySiteAndMaterial = {};
  state?.forEach((city) => {
    city.city_wise_pr?.forEach((cityDetail) => {
      cityDetail.site_wise_details?.forEach((site) => {
        const siteName = site.site_name;
        if (!uniqueMasterIdsBySiteAndMaterial[siteName]) {
          uniqueMasterIdsBySiteAndMaterial[siteName] = {};
        }
        site.material_wise_details?.forEach((material) => {
          const materialTypeName = material.material_type_name;
          if (!uniqueMasterIdsBySiteAndMaterial[siteName][materialTypeName]) {
            uniqueMasterIdsBySiteAndMaterial[siteName][materialTypeName] = new Set();
          }
          if (material.purchase_requisition_master_id) {
            uniqueMasterIdsBySiteAndMaterial[siteName][materialTypeName].add(
              material.purchase_requisition_master_id
            );
          }
        });
      });
    });
  });

  const tableData = [];
  const length = state[0].city_wise_pr.length;
  setCityLength(length);

  state.forEach((prObject, prIndex) => {
    prObject.city_wise_pr.forEach((city, cityIndex) => {
      const cityRowSpan = city.site_wise_details.length;
      let cityTotalQuantity = 0;
      let cityTotalQuantityInKg = 0;
      let cityTotal = 0;
      let cityTotalWithKG = 0;
      city.site_wise_details.forEach((site, siteIndex) => {
        let siteTotalQuantity = 0;
        let siteTotalQuantityInKg = 0;
        let siteMaterialTotalAmount = 0;
        let siteMaterialTotalAmountWithKG = 0;

        const groupedData = {};
        site.material_wise_details.forEach((material) => {
          const rfqId = material.purchase_requisition_material_id || null;
          const rfqActualId = material.rfq_material_id || null;
          rfqPresent = material.rfq_material_id;

          if (!groupedData[rfqId]) {
            groupedData[rfqId] = {
              rfq_material_id: rfqId,
              site_id: site.site_id,
              rfqActualId: rfqActualId,
              site_name: site.site_name,
              material_type_names: new Set([material.material_type_name]),
              material_type_sub_category: material.material_type_sub_category,
              pr_total_quantity: material.pr_total_quantity,
              pr_total_quantity_by_kg: material.pr_total_quantity_by_kg,
              estimated_material_unit_price: material.estimated_material_unit_price,
              pr_total_amount: material.pr_total_amount,
              material_type_uom: material.material_type_uom,
              material_type_uom_name: material.preferred_unit_of_measurement || material.material_type_uom_name,
              preferred_unit_of_measurement: material.preferred_unit_of_measurement,
              preferred_unit_of_measurement_id: material.preferred_unit_of_measurement_id,
              purchase_requisition_material_id: material.purchase_requisition_material_id,
            };
          } else {
            groupedData[rfqId].material_type_names.add(material.material_type_name);
            groupedData[rfqId].pr_total_quantity += material.pr_total_quantity;
            groupedData[rfqId].pr_total_amount += material.pr_total_amount;
          }
        });

        const result = Object.values(groupedData).map((item) => ({
          ...item,
          material_type_names: Array.from(item.material_type_names).join(", "),
        }));

        const materialGroups = site.material_wise_details.reduce((acc, material, index) => {
          if (material.purchase_requisition_master_id) {
            uniqueMasterIds.add(material.purchase_requisition_master_id);
          }
          const {
            material_type_name,
            material_type_uom_name,
            preferred_unit_of_measurement,
            pr_total_quantity,
            pr_total_quantity_by_kg,
            estimated_material_unit_price,
            pr_total_amount,
            purchase_requisition_master_id,
            actual_quantity,
            rfq_material_id,
            purchase_requisition_material_id,
            preferred_unit_of_measurement_id,
            material_type_uom,
            remark,
            vendors,
            material_type_sub_category,
          } = material;

          if (!acc[material_type_name]) {
            acc[material_type_name] = {
              material_type_name,
              preferred_unit_of_measurement,
              material_type_uom_name: preferred_unit_of_measurement || material_type_uom_name,
              total_quantity: 0,
              actual_quantity: 0,
              total_quantity_by_kg: 0,
              total_amount: 0,
              estimated_material_unit_price,
              purchase_requisition_master_ids: new Set(),
              rfq_material_id,
              purchase_requisition_material_id,
              preferred_unit_of_measurement_id,
              material_type_uom,
              remark,
              vendors,
              siteIndex,
              cityIndex,
              index,
              material_type_sub_category,
            };
          }

          const currentSiteName = site.site_name;
          const currentMaterialTypeName = material_type_name;
          const uniqueMasterIdss =
            uniqueMasterIdsBySiteAndMaterial[currentSiteName]?.[currentMaterialTypeName] || [];

          const conversionForSand = city.sand_conversion || 1.6;
          const conversionForAggregate = city.aggregate_conversion || 1.45;


          let convertedQuantity = pr_total_quantity;
          let convertedQuantityInKg = pr_total_quantity_by_kg;
          let finalUOM = preferred_unit_of_measurement || material_type_uom_name;
                console.log("pr_total_quantity_by_kgdd", pr_total_quantity_by_kg);

          if (uniqueMasterIdss.size > 1 && rfq_material_id === null) {
            if (material_type_name?.includes("Sand")) {
              if (preferred_unit_of_measurement === "MT") {
                convertedQuantity = pr_total_quantity_by_kg / 1000; 
              } else if (preferred_unit_of_measurement === "Cum.") {
                convertedQuantity = pr_total_quantity_by_kg / (conversionForSand * 1000); 
              } else if (preferred_unit_of_measurement === "KG") {
                convertedQuantity = pr_total_quantity_by_kg;
              } else if (preferred_unit_of_measurement === "Bag") {
                convertedQuantity = pr_total_quantity_by_kg / 50; 
              }
            } else if (state.category_tree_name?.includes("Aggregate")) {

              if (preferred_unit_of_measurement === "MT") {
                convertedQuantity = pr_total_quantity_by_kg / 1000; 
              } else if (preferred_unit_of_measurement === "Cum.") {
                
                convertedQuantity = pr_total_quantity_by_kg / (conversionForAggregate * 1000); 
              } else if (preferred_unit_of_measurement === "KG") {
                convertedQuantity = pr_total_quantity_by_kg;
              } else if (preferred_unit_of_measurement === "Bag") {
                convertedQuantity = pr_total_quantity_by_kg / 50; 
              }
            } else {
              if (preferred_unit_of_measurement === "MT") {
                convertedQuantity = pr_total_quantity_by_kg / 1000; 
              } else if (preferred_unit_of_measurement === "Cum.") {
                convertedQuantity = pr_total_quantity_by_kg / 1600; 
              } else if (preferred_unit_of_measurement === "KG") {
                convertedQuantity = pr_total_quantity_by_kg;
              } else if (preferred_unit_of_measurement === "Bag") {
                convertedQuantity = pr_total_quantity_by_kg / 50; 
              }
            }
            finalUOM = preferred_unit_of_measurement || material_type_uom_name;
          } else {
            if (material_type_name.includes("Sand")) {
              if (preferred_unit_of_measurement === "MT") {
                convertedQuantity = pr_total_quantity_by_kg / 1000; 
              } else if (preferred_unit_of_measurement === "Cum.") {
                convertedQuantity = pr_total_quantity_by_kg / (conversionForSand * 1000); // KG to Cum.
              } else if (preferred_unit_of_measurement === "KG") {
                convertedQuantity = pr_total_quantity_by_kg;
              } else if (preferred_unit_of_measurement === "Bag") {
                convertedQuantity = pr_total_quantity_by_kg / 50; 
              }
            } else if (state?.category_tree_name?.includes("Aggregate")) {

              if (preferred_unit_of_measurement === "MT") {
                convertedQuantity = pr_total_quantity_by_kg / 1000; 
              } else if (preferred_unit_of_measurement === "Cum.") {
                convertedQuantity = pr_total_quantity_by_kg / (conversionForAggregate * 1000); // KG to Cum.
              } else if (preferred_unit_of_measurement === "KG") {
                convertedQuantity = pr_total_quantity_by_kg;
              } else if (preferred_unit_of_measurement === "Bag") {
                convertedQuantity = pr_total_quantity_by_kg / 50; 
              }
            }
            else{
              convertedQuantity = pr_total_quantity;
              convertedQuantityInKg = pr_total_quantity_by_kg;
              // finalUOM = preferred_unit_of_measurement || material_type_uom_name;
              finalUOM = material_type_uom_name || preferred_unit_of_measurement;
            }

          }

          acc[material_type_name].total_quantity += convertedQuantity;
          acc[material_type_name].actual_quantity += convertedQuantity;
          acc[material_type_name].total_quantity_by_kg += convertedQuantityInKg;
          acc[material_type_name].total_amount += pr_total_amount;
          acc[material_type_name].material_type_uom_name = finalUOM;
          acc[material_type_name].preferred_unit_of_measurement = finalUOM;

          const uomOption = uomList.find(
            (option) => option.unit_of_measurement === finalUOM
          );
          acc[material_type_name].material_type_uom = uomOption ? uomOption.id : material_type_uom;
          acc[material_type_name].preferred_unit_of_measurement_id = uomOption
            ? uomOption.id
            : material_type_uom;

          if (purchase_requisition_master_id) {
            acc[material_type_name].purchase_requisition_master_ids.add(
              purchase_requisition_master_id
            );
          }

          return acc;
        }, {});

        let groupedMaterials = Object.values(materialGroups).map((material) => {
          let unitMeasurement = material.preferred_unit_of_measurement;
          let unitMeasurementId = material.preferred_unit_of_measurement_id;

          if (
            Array.from(material.purchase_requisition_master_ids).length > 1 &&
            material.rfq_material_id === null
          ) {
            const uomOption = memoizedPincodeList.find(
              (option) => option.unit_of_measurement === material.preferred_unit_of_measurement
            );
            unitMeasurement = material.preferred_unit_of_measurement;
            unitMeasurementId = uomOption ? uomOption.id : material.material_type_uom;
          } else {
            unitMeasurement = material.material_type_uom_name;
            unitMeasurementId = material.material_type_uom;
          }

          return {
            ...material,
            material_type_uom: unitMeasurementId,
            material_type_uom_name: unitMeasurement,
            purchase_requisition_master_ids: Array.from(
              material.purchase_requisition_master_ids
            ),
          };
        });

        groupedMaterials.forEach((material) => {
          siteTotalQuantity += material.total_quantity;
          siteMaterialTotalAmount += material.total_amount;
          siteTotalQuantityInKg += material.total_quantity_by_kg;

          if (material.material_type_sub_category === "RMC") {
            siteMaterialTotalAmountWithKG +=
              material.total_quantity * material.estimated_material_unit_price;
          } else {
            siteMaterialTotalAmountWithKG +=
              material.total_quantity_by_kg * material.estimated_material_unit_price;
          }
        });

        site.site_total_quantity = siteTotalQuantity;
        cityTotalQuantity += siteTotalQuantity;
        cityTotalQuantityInKg += siteTotalQuantityInKg;
        cityTotal += siteMaterialTotalAmount;
        cityTotalWithKG += siteMaterialTotalAmountWithKG;

        tableData.push({
          key: `${prIndex}-${cityIndex}-${siteIndex}`,
          srNo: length > 1 ? (siteIndex === 0 ? cityIndex + 1 : null) : siteIndex + 1,
          cityName: siteIndex === 0 ? city.city_name : "",
          cityName1: city.city_name,
          cityRowSpan: siteIndex === 0 ? cityRowSpan : 0,
          siteName: site.site_name,
          siteName1: site.site_name,
          siteData: result,
          siteLocations: groupedMaterials.map((material, ind) => {
            return {
              vendors: material?.vendors,
              cityName: city.city_name,
              cityIndex: material.cityIndex,
              siteIndex: material.cityIndex,
              siteId: site.site_name,
              matInd: ind,
              materialName: material.material_type_name,
              quantity: material.total_quantity.toFixed(3),
              actual_quantity: material.actual_quantity,
              quantity_by_kg: material.total_quantity_by_kg.toLocaleString("en-IN", {
                maximumFractionDigits: 0,
              }),
              remark: material.remark,
              uom: material.preferred_unit_of_measurement,
              uom_pref: material.preferred_unit_of_measurement_id,
              subCategory: material.material_type_sub_category,
              estimatedPrice: material.estimated_material_unit_price,
              materialTotal: material.total_amount,
              unit_measurement: material.material_type_uom,
              unit_measurement_id: material.material_type_uom,
              unit_measurement_name: material.material_type_uom_name,
              purchase_master_ids: [...material.purchase_requisition_master_ids],
              purchase_requisition_material_id: material.purchase_requisition_material_id,
              rfq_material_idd: material.rfq_material_id,
              sand_conversion: city.sand_conversion,
              aggregate_conversion: city.aggregate_conversion
            };
          }),
          totalAmount: (
            <Input
              disabled
              value={`\u20B9 ${siteMaterialTotalAmount || 0}`}
              className="site-subtotal"
            />
          ),
        });

        tableData.push({
          key: `${prIndex}-${cityIndex}-${siteIndex}-SiteSubTotal`,
          siteName: "Site Sub-Total",
          siteLocations: [
            {
              totalQuantity: siteMaterialTotalAmountWithKG,
              materialName: "",
              quantity: "",
              quantity_by_kg: "",
              subCategory: "",
              siteIndex,
              cityId: city.city_id,
              siteId: site.site_id,
            },
          ],
          totalAmount: (
            <Input
              disabled
              value={`\u20B9 ${siteMaterialTotalAmount || 0}`}
              className="site-subtotal"
            />
          ),
          siteTotalQuantity: (
            <Input
              disabled
              value={
                siteTotalQuantity?.toLocaleString("en-IN", {
                  maximumFractionDigits: 0,
                }) || 0
              }
              className="site-total-quantity"
              readOnly
            />
          ),
        });

        if (length > 1 && siteIndex === city.site_wise_details.length - 1) {
          tableData.push({
            key: `${prIndex}-${cityIndex}-${siteIndex}-CityTotal`,
            siteName: "City Total",
            siteLocations: [
              {
                materialName: "",
                cityTotal: cityTotalWithKG,
                quantity: "",
                quantity_by_kg: "",
                subCategory: "",
                siteIndex,
                cityId: city.city_id,
                siteId: site.site_id,
              },
            ],
            totalAmount: cityTotal,
            cityTotalQuantity: (
              <Input
                disabled
                value={cityTotalQuantity || 0}
                className="city-total-quantity"
                readOnly
              />
            ),
          });
        }
      });

      city.city_total_quantity = cityTotal;
    });
  });
  
  setTableData(tableData);
  setapiLoading(false);
};

  const updateWbsData = (state) => {
    const tableData = [];
    const length = state[0]?.city_wise_pr?.length;
    setCityLength(length);

    state?.forEach((prObject, prIndex) => {
      prObject?.city_wise_pr?.forEach((city, cityIndex) => {
        let cityTotalQuantity = 0;
        let cityTotal = 0;

        city?.site_wise_details?.forEach((site, siteIndex) => {
          let siteTotalQuantity = 0;
          let siteMaterialTotal = 0;
          let siteMaterialTotalAmount = 0;
          let newSites = 0;

          site?.material_wise_details?.forEach((material) => {
            siteTotalQuantity += material?.pr_total_quantity;

            siteMaterialTotalAmount += material?.pr_total_amount;

            siteMaterialTotal +=
              material?.pr_total_quantity *
              material?.estimated_material_unit_price;
          });

          cityTotalQuantity += siteTotalQuantity;
          cityTotal += siteMaterialTotalAmount;

          tableData.push({
            prNumber: prObject.pr,
            srNo:
              length > 1
                ? siteIndex === 0
                  ? cityIndex + 1
                  : null
                : siteIndex + 1,
            cityName: siteIndex === 0 ? city.city_name : null,
            key: `${prObject.pr}-${prIndex}-${cityIndex}-${siteIndex}`,
            siteName: site.site_name,
            siteLocations: site.material_wise_details?.map(
              (material, matIndex) => ({
                materialTotal: material.pr_total_amount,
                availableBudget: material.available_budget || 0,
                estimatedPRValue: newSites || 0,
                materialName: material.material_type_name,
                quantity: material.material_type_quantity,
                uom: material.material_type_uom,
                subCategory: material.material_type_sub_category,
                siteIndex,
                matIndex,
                siteId: site.site_id,
                estimatedPrice: material.estimated_material_unit_price,
              })
            ),
          });
        });
        if (length > 1) {
          tableData.push({
            prNumber: prObject.pr,
            key: `${prObject.pr}-${prIndex}-${cityIndex}-CityTotal`,
            siteName: "City Total",
            siteLocations: [
              {
                cityTotal: cityTotal,
              },
            ],
            totalAmount: (
              <Input
                disabled
                value={`\u20B9 ${cityTotal || 0}`}
                className="subtotal"
                readOnly
              />
            ),
          });
        }
      });
    });

    setStateWBS(tableData);
  };

  useEffect(() => {
    setapiLoading(true);
    if (response.pr_city_wise_by_pr_number !== null) {
      setRes(response);
      updateTableData(response?.pr_city_wise_by_pr_number);
      setOldResponse(response?.pr_city_wise_by_pr_number);
      updateWbsData(response?.pr_city_wise_by_pr_number);

      setRfqIDD(response?.rfq_details[0]?.id);
      setMasterId(response?.rfq_details[0].id);
    }

    if (
      Array.isArray(response?.rfq_material_details) &&
      response?.rfq_material_details.length === 0
    ) {
      setRfqMaterialDetailsID(false);
    } else {
      setRfqMaterialDetailsID(true);
    }
    setapiLoading(false);
  }, [response, res, uomList]);

  const getSiteName = async () => {
    try {
      let apiResponse = await getRequest(
        `delivery-address/${CompanyID}/address-by-company/`
      );
      if (apiResponse.data.data) {
        setSiteName(apiResponse.data.data);
        const updatedState = { ...state };
        updatedState.purchase_requisition_details.forEach((detail) => {
          detail.site_wise.forEach((site, index) => {
            site.site_name = apiResponse.data.data[index]
              ? apiResponse.data.data[index].site.id
              : null;
          });
        });
        setState(updatedState);
      } else {
        ErrorNotificationMsg(t("error_in_company_adress_list"));
      }
    } catch (error) {
      //setLoading(false);
    }
  };

  const handleVendorChange = (value, cityName, siteName, matIndex) => {
    setTableData((prevState) => {
      const newState = prevState.map((row) => {
        if (row.cityName1 === cityName && row.siteName1 === siteName) {
          const updatedRow = { ...row };
          if (updatedRow.siteLocations && updatedRow.siteLocations[matIndex]) {
            const updatedMaterial = { ...updatedRow.siteLocations[matIndex] };
            updatedMaterial.vendor = value;
            updatedRow.siteLocations[matIndex] = updatedMaterial;
            if (updatedRow.siteData && updatedRow.siteData[matIndex]) {
              const updatedSiteDataMaterial = {
                ...updatedRow.siteData[matIndex],
                vendor: value,
              };
              updatedRow.siteData[matIndex] = updatedSiteDataMaterial;
            }
          }

          return updatedRow;
        }

        return row;
      });

      return newState;
    });
    setSelectedVendors(value);
  };

  // const handleUOMChange = (
  //   value,
  //   cityName,
  //   siteName,
  //   matIndex,
  //   unitOfMeasurement,
  //   newQuantity
  // ) => {
  //   setTableData((prevState) => {
  //     const newState = prevState.map((row) => {
  //       if (row.cityName1 === cityName && row.siteName1 === siteName) {
  //         const updatedRow = { ...row };

  //         if (updatedRow.siteLocations && updatedRow.siteLocations[matIndex]) {
  //           const updatedMaterial = { ...updatedRow.siteLocations[matIndex] };

  //           const originalUOM =
  //             updatedMaterial.unit_measurement_name || updatedMaterial.uom;
  //           const originalQuantity = parseFloat(updatedMaterial.quantity || 0);

  //           updatedMaterial.uom = value;
  //           updatedMaterial.unit_measurement = value;
  //           updatedMaterial.uom_pref = value;
  //           updatedMaterial.unit_measurement_name = unitOfMeasurement;

  //           let quantityInKG = 0;

  //           if (originalUOM === "Cum.") {
  //             quantityInKG = originalQuantity * 1600;
  //           } else if (originalUOM === "Cubic Meter") {
  //             quantityInKG = originalQuantity * 1600;
  //           } else if (originalUOM === "MT") {
  //             quantityInKG = originalQuantity * 1000;
  //           } else if (originalUOM === "Bag") {
  //             quantityInKG = originalQuantity * 50;
  //           } else if (originalUOM === "KG") {
  //             quantityInKG = originalQuantity;
  //           } else {
  //             quantityInKG = originalQuantity;
  //           }

  //           let adjustedQuantity = 0;

  //           if (unitOfMeasurement === "Cum.") {
  //             adjustedQuantity = quantityInKG / 1600;
  //           } else if (unitOfMeasurement === "Cubic Meter") {
  //             adjustedQuantity = quantityInKG / 1600;
  //           } else if (unitOfMeasurement === "MT") {
  //             adjustedQuantity = quantityInKG / 1000;
  //           } else if (unitOfMeasurement === "Bag") {
  //             adjustedQuantity = quantityInKG / 50;
  //           } else if (unitOfMeasurement === "KG") {
  //             adjustedQuantity = quantityInKG;
  //           } else {
  //             adjustedQuantity = quantityInKG;
  //           }

  //           updatedMaterial.quantity = adjustedQuantity.toFixed(3);

  //           if (updatedRow.siteData && updatedRow.siteData[matIndex]) {
  //             const updatedSiteDataMaterial = {
  //               ...updatedRow.siteData[matIndex],
  //               material_type_uom_name: unitOfMeasurement,
  //               unit_measurement: value,
  //               uom_pref: value,
  //               pr_total_quantity: adjustedQuantity,
  //               pr_total_quantity_by_kg: quantityInKG,
  //             };
  //             updatedRow.siteData[matIndex] = updatedSiteDataMaterial;
  //           }

  //           updatedRow.siteLocations[matIndex] = updatedMaterial;
  //           return updatedRow;
  //         }
  //       }

  //       if (row.siteName === "Site Sub-Total" && row.cityName === cityName) {
  //         const updatedRow = { ...row };

  //         const siteTotalQuantity = newState
  //           .filter((r) => r.cityName === cityName && r.siteName === siteName)
  //           .reduce((total, r) => {
  //             r.siteLocations?.forEach((loc) => {
  //               total += parseFloat(loc.quantity || 0);
  //             });
  //             return total;
  //           }, 0);

  //         const siteTotalAmount = newState
  //           .filter((r) => r.cityName === cityName && r.siteName === siteName)
  //           .reduce((total, r) => {
  //             r.siteLocations?.forEach((loc) => {
  //               total += parseFloat(loc.materialTotal || 0);
  //             });
  //             return total;
  //           }, 0);

  //         if (updatedRow.siteLocations?.[0]) {
  //           updatedRow.siteLocations[0].quantity = siteTotalQuantity.toFixed(3);
  //         }
  //         updatedRow.totalAmount = `\u20B9 ${siteTotalAmount.toLocaleString(
  //           "en-IN"
  //         )}`;

  //         return updatedRow;
  //       }

  //       return row;
  //     });

  //     return newState;
  //   });
  // };

  const handleUOMChange = (
    value,
    cityName,
    siteName,
    matIndex,
    unitOfMeasurement,
    newQuantity
  ) => {
    setTableData((prevState) => {
      const newState = prevState.map((row) => {
        if (row.cityName1 === cityName && row.siteName1 === siteName) {
          const updatedRow = { ...row };

          if (updatedRow.siteLocations && updatedRow.siteLocations[matIndex]) {
            const updatedMaterial = { ...updatedRow.siteLocations[matIndex] };
            console.log("updatedMaterialw", updatedMaterial);
            
            const originalUOM =
              updatedMaterial.unit_measurement_name || updatedMaterial.uom;
            const originalQuantity = parseFloat(updatedMaterial.quantity || 0);
            const isSand = updatedMaterial.materialName.includes("Sand");
            const isAggregate = updatedMaterial.materialName.includes("Aggregate") || updatedMaterial.materialName.includes("Dust");
            
            const conversionForSand = updatedMaterial.sand_conversion; 
            const conversionForAggregate = updatedMaterial.aggregate_conversion; 


            let quantityInKG = 0;
            if (originalUOM === "Cum." || originalUOM === "Cubic Meter") {
              quantityInKG = isSand
                ? originalQuantity * (conversionForSand * 1000) 
                : isAggregate ? originalQuantity * (conversionForAggregate * 1000) : originalQuantity * 1600;
            } else if (originalUOM === "MT") {
              quantityInKG = originalQuantity * 1000; 
            } else if (originalUOM === "Bag") {
              quantityInKG = originalQuantity * 50;
            } else if (originalUOM === "KG") {
              quantityInKG = originalQuantity; 
            } else {
              quantityInKG = originalQuantity; 
            }

            let adjustedQuantity = 0;
            if (
              unitOfMeasurement === "Cum." && isSand
            ) {
              adjustedQuantity = quantityInKG / (conversionForSand * 1000) 
             
            } else if (
              unitOfMeasurement === "Cum." && isAggregate
            ) {
              adjustedQuantity = quantityInKG / (conversionForAggregate * 1000) 
             
            }
            else if (
              unitOfMeasurement === "Cubic Meter"
            ) {
              adjustedQuantity = isSand
                ? quantityInKG / (conversionForSand * 1000) 
                : quantityInKG / 1600;
            } else if (unitOfMeasurement === "MT") {
              adjustedQuantity = quantityInKG / 1000; 
            } else if (unitOfMeasurement === "Bag") {
              adjustedQuantity = quantityInKG / 50; 
            } else if (unitOfMeasurement === "KG") {
              adjustedQuantity = quantityInKG; 
            } else {
              adjustedQuantity = quantityInKG; 
            }

            updatedMaterial.uom = value;
            updatedMaterial.unit_measurement = value;
            updatedMaterial.uom_pref = value;
            updatedMaterial.unit_measurement_name = unitOfMeasurement;
            updatedMaterial.quantity = adjustedQuantity.toFixed(3);
            // updatedMaterial.quantity_by_kg = quantityInKG.toLocaleString("en-IN", {
            //   maximumFractionDigits: 0,
            // });

            if (updatedRow.siteData && updatedRow.siteData[matIndex]) {
              const updatedSiteDataMaterial = {
                ...updatedRow.siteData[matIndex],
                material_type_uom_name: unitOfMeasurement,
                unit_measurement: value,
                uom_pref: value,
                pr_total_quantity: adjustedQuantity,
                // pr_total_quantity_by_kg: quantityInKG,
              };
              updatedRow.siteData[matIndex] = updatedSiteDataMaterial;
            }

            updatedRow.siteLocations[matIndex] = updatedMaterial;
            return updatedRow;
          }
        }

        if (row.siteName === "Site Sub-Total" && row.cityName === cityName) {
          const updatedRow = { ...row };

          const siteTotalQuantity = newState
            .filter((r) => r.cityName === cityName && r.siteName === siteName)
            .reduce((total, r) => {
              r.siteLocations?.forEach((loc) => {
                total += parseFloat(loc.quantity || 0);
              });
              return total;
            }, 0);

          const siteTotalAmount = newState
            .filter((r) => r.cityName === cityName && r.siteName === siteName)
            .reduce((total, r) => {
              r.siteLocations?.forEach((loc) => {
                total += parseFloat(loc.materialTotal || 0);
              });
              return total;
            }, 0);

          if (updatedRow.siteLocations?.[0]) {
            updatedRow.siteLocations[0].quantity = siteTotalQuantity.toFixed(3);
          }
          updatedRow.totalAmount = `\u20B9 ${siteTotalAmount.toLocaleString(
            "en-IN"
          )}`;

          return updatedRow;
        }

        return row;
      });

      return newState;
    });
  };

  const wbsBudget = [
    {
      title: "SR.",
      dataIndex: "srNo",
      fixed: "left",
      width: 50,
    },
    {
      title: "Site",
      dataIndex: "siteName",
      fixed: "left",
      width: 200,
      render: (text) => <div className="lblvalue">{text}</div>,
    },
    {
      title: "Available Budget",
      dataIndex: "siteLocations",
      align: "right",
      width: 200,
      render: (siteLocations, record) => {
        let totalAvail = 10000000;
        if (record.siteName !== "City Total" && record.siteName !== "Total") {
          return (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
              }}
            >
              <div
                key={1}
                className="lblvalue"
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  width: "100px",
                }}
              >
                ₹{" "}
                {totalAvail?.toLocaleString("en-IN", {
                  maximumFractionDigits: 0,
                })}
              </div>
            </div>
          );
        }
        return null;
      },
    },
    {
      title: "Estimated PR Value",
      dataIndex: "siteLocations",
      align: "right",
      render: (siteLocations, record) => {
        if (record.siteName === "City Total" || record.siteName === "Total") {
          return (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
              }}
            >
              <div
                className="lblvalue"
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  width: "110px",
                }}
              >
                ₹{" "}
                {siteLocations[0].cityTotal?.toLocaleString("en-IN", {
                  maximumFractionDigits: 0,
                })}
              </div>
            </div>
          );
        } else {
          let total = siteLocations.reduce(
            (acc, site) => acc + site.materialTotal,
            0
          );

          return (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
              }}
            >
              <div
                key={1}
                className="lblvalue"
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  width: "110px",
                }}
              >
                ₹{" "}
                {total
                  ? total?.toLocaleString("en-IN", { maximumFractionDigits: 0 })
                  : 0}
              </div>
            </div>
          );
        }
      },
    },
  ];

  if (cityLength > 1) {
    wbsBudget.splice(1, 0, {
      title: "City",
      dataIndex: "cityName",
      key: "cityName",
      width: 150,
      render: (text) => <div className="lblvalue">{text}</div>,
    });
  }

  const columns = [
    {
      title: "Sr.",
      dataIndex: "srNo",
      width: 40,
    },
    {
      title: "Site",
      dataIndex: "siteName",
      width: 130,
      render: (siteLocations, record) => {
        if (record.siteName === "Site Sub-Total") {
          return {
            children: <div className="subtotal">Sub Total</div>,
          };
        } else if (record.siteName === "City Total") {
          return {
            children: <div className="citytotal">{record.siteName}</div>,
          };
        } else {
          return <div>{record.siteName}</div>;
        }
      },
    },

    {
      title: "Item",
      dataIndex: "siteLocations",
      width: 120,
      render: (siteLocations) => (
        <div style={{ display: "flex", flexDirection: "column", gap: "22px" }}>
          {siteLocations.map((site, index) => (
            <div key={index} className="lblvalue">
              {site.materialName}
            </div>
          ))}
        </div>
      ),
    },
    {
      title: "Qty.",
      dataIndex: "siteLocations",
      width: 80,
      align: "center",
      render: (siteLocations, record) => {
        const renderInput = (site, index) => {
          const quantity = parseFloat(site.quantity);

          return (
            <div
              key={index}
              className="lblvalue"
              style={{
                display: "flex",
                justifyContent: "center",
                textAlign: "center",
              }}
            >
              {isNaN(quantity)
                ? ""
                : site.materialName.includes("Sand")
                ? quantity?.toFixed(2)
                : quantity?.toFixed(2)}{" "}
            </div>
          );
        };

        return (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "22px",
            }}
          >
            {siteLocations.map(renderInput)}
          </div>
        );
      },
    },
{
  title: (
    <Tooltip
      color="#094E8F"
      placement="top"
      title={
        <span style={{ color: "#fff" }}>
          Preferred Unit of measurement means Your company buys material
          generally in this unit of measurement
        </span>
      }
    >
      Preferred UoM.
    </Tooltip>
  ),
  width: 130,
  dataIndex: "siteLocations",
  render: useCallback(
    (siteLocations, record) => {
      if (
        record.siteName === "City Total" ||
        record.siteName === "Site Sub-Total"
      ) {
        return "";
      }
      if (!memoizedPincodeList || memoizedPincodeList.length === 0) {
        return <div>Loading UoM...</div>;
      }

      if (
        siteLocations &&
        siteLocations.length > 0 &&
        siteLocations[0].materialName !== ""
      ) {
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "10px",
            }}
          >
            {siteLocations.map((site, index) => {
              console.log('siddddfte', site)
              let defaultValue = site.uom_pref || 1; 
              let defaultName = site.preferred_unit_of_measurement || "MT"; 
              let adjustedQuantity = parseFloat(site.quantity || 0);

              const hasMultipleMasterIds =
                site.purchase_master_ids &&
                site.purchase_master_ids.length > 1 &&
                site.rfq_material_idd === null;

              const conversionForSand = site.sand_conversion; 
              const conversionForAggregate = site.aggregate_conversion; 


              if (hasMultipleMasterIds) {
                const preferredOption = memoizedPincodeList.find(
                  (option) => option.id === site.uom_pref
                );
                defaultName = preferredOption
                  ? preferredOption.unit_of_measurement
                  : site.preferred_unit_of_measurement || "MT";
                defaultValue = preferredOption
                  ? preferredOption.id
                  : site.uom_pref || 1;

                const isSand = site.materialName.includes("Sand");
                const isAggregate = site.materialName.includes("Aggregate") || site.materialName.includes("Dust");

                
                const quantityInKg = parseFloat(site.quantity_by_kg.replace(/,/g, "") || 0);

                if (defaultName === "MT") {
                  adjustedQuantity = quantityInKg / 1000; 
                } else if (defaultName === "Cum.") {
                  adjustedQuantity = isSand
                    ? quantityInKg / (conversionForSand * 1000) 
                    : isAggregate ? quantityInKg / (conversionForAggregate * 1000) : quantityInKg / 1600; 
                } else if (defaultName === "KG") {
                  adjustedQuantity = quantityInKg;
                } else if (defaultName === "Bag") {
                  adjustedQuantity = quantityInKg / 50;
                }
              } else {
                const currentOption = memoizedPincodeList.find(
                  (option) => option.id === site.unit_measurement
                );
                defaultValue = currentOption ? currentOption.id : site.unit_measurement || 1;
                defaultName = currentOption
                  ? currentOption.unit_of_measurement
                  : site.unit_measurement_name || "MT";
                adjustedQuantity = parseFloat(site.quantity || 0);
              }
              if (defaultName === "Cubic Meter") {
                    return (
                      <div key={index}>
                        <Select
                          style={{ width: "90%" }}
                          defaultValue={defaultValue}
                          suffixIcon={null}
                          open={false}
                        >
                          {memoizedPincodeList.map((option) => {
                            return (
                            <Option
                              key={option.id}
                              value={option.id}
                              style={{ paddingRight: "0px" }}
                            >
                              <span
                                style={{ color: "black", fontSize: "11px" }}
                              >
                                {option.id === 4
                                  ? "Cu. Mtr."
                                  : option.unit_of_measurement}
                              </span>
                            </Option>
                          )})}
                        </Select>
                      </div>
                    );
                  }
              else {
                return (
                  <div key={index}>
                    <Select
                      style={{ width: "90%" }}
                      value={defaultName === "Cubic Meter" ? "Cu. Mtr." : defaultValue} 
                      disabled={defaultName === "Cubic Meter"}
                      onChange={(value) => {
                        const selectedOption = memoizedPincodeList.find(
                          (option) => option.id === value
                        );
                        handleUOMChange(
                          value,
                          site.cityName,
                          site.siteId,
                          site.matInd,
                          selectedOption ? selectedOption.unit_of_measurement : null,
                          adjustedQuantity
                        );
                      }}
                    >
                      {memoizedPincodeList
                        .filter((i) => i.unit_of_measurement !== "Cubic Meter")
                        .map((option) => (
                          <Option key={option.id} value={option.id}>
                            {option.unit_of_measurement}
                          </Option>
                        ))}
                    </Select>
                  </div>
                );

              }
            })}
          </div>
        );
      }
      return null;
    },
    [memoizedPincodeList]
  ),
},
    {
      title: "Qty. In Kg",
      dataIndex: "siteLocations",
      width: 100,
      align: "right",
      render: (siteLocations, record) => {
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "22px",
            }}
          >
            {siteLocations.map((site, index) => {
              return (
                <div
                  key={index}
                  className="lblvalue"
                  style={{ display: "flex", justifyContent: "flex-end" }}
                >
                  {site.quantity_by_kg == 0 && site.subCategory === "RMC"
                    ? "-"
                    : site.quantity_by_kg?.toLocaleString("en-IN", {
                        maximumFractionDigits: 0,
                      }) || ""}
                </div>
              );
            })}
          </div>
        );
      },
    },
    {
      title: (
        <Tooltip
          title="Reference price of estimated unit rate comes from material master data"
          color="#094E8F"
          placement="top"
        >
          <span>Est. Unit rate</span>
        </Tooltip>
      ),
      dataIndex: "siteLocations",
      width: 130,
      align: "right",
      render: (siteLocations, record) => {
        if (
          record.siteName !== "Site Sub-Total" &&
          record.siteName !== "City Total"
        ) {
          return (
            <>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "22px",
                }}
              >
                {siteLocations.map((site, index) => {
                  return (
                    <div
                      key={index}
                      className="lblvalue"
                      style={{ display: "flex", justifyContent: "flex-end" }}
                    >
                      ₹ {site.estimatedPrice}{" "}
                      {site.subCategory === "RMC"
                        ? "/ Cu.M."
                        : site.materialName.includes("Sand") || site.materialName.includes("Aggregate") || site.materialName.includes("Dust")
                        ? `/ MT`
                        : "/ Kg"}
                    </div>
                  );
                })}
              </div>
            </>
          );
        }
      },
    },
    {
      title: "Est. Amount",
      dataIndex: "siteLocations",
      align: "right",
      width: "130px",
      render: (siteLocations, record) => {
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "22px",
              alignItems: "flex-end",
            }}
          >
            {siteLocations.map((site, index) => {
              let total = 0;

              if (site?.subCategory === "RMC") {
                total =
                  site?.subCategory === "RMC"
                    ? Number(site?.quantity) * site?.estimatedPrice
                    : site?.materialTotal;
              } else {
                total =
                  Number(site?.quantity_by_kg.replace(/,/g, "")) *
                  site?.estimatedPrice;
              }

              if (site.materialName !== "") {
                return (
                  <div
                    key={index}
                    className="lblvalue "
                    style={{ display: "flex", justifyContent: "flex-end" }}
                  >
                    ₹{" "}
                    {total?.toLocaleString("en-IN", {
                      maximumFractionDigits: 0,
                    }) || ""}
                  </div>
                );
              } else if (record.siteName === "Site Sub-Total") {
                return (
                  <div
                    key={index}
                    className="lblvalue subtotal"
                    style={{ display: "flex", justifyContent: "flex-end" }}
                  >
                    ₹{" "}
                    <span>
                      {site?.totalQuantity.toLocaleString("en-IN", {
                        maximumFractionDigits: 0,
                      })}
                    </span>
                  </div>
                );
              } else if (record.siteName === "City Total") {
                return (
                  <div
                    key={index}
                    className="lblvalue citytotal"
                    style={{ display: "flex", justifyContent: "flex-end" }}
                  >
                    ₹{" "}
                    <span>
                      {site.cityTotal.toLocaleString("en-IN", {
                        maximumFractionDigits: 0,
                      })}
                    </span>
                  </div>
                );
              } else {
                return (
                  <div
                    key={index}
                    className="lblvalue"
                    style={{ display: "flex", justifyContent: "flex-end" }}
                  >
                    ₹{" "}
                    {site?.totalQuantity?.toLocaleString("en-IN", {
                      maximumFractionDigits: 0,
                    }) || ""}
                  </div>
                );
              }
            })}
          </div>
        );
      },
    },
    {
      title: (
        <Tooltip color="#094E8F" placement="top">
          <span style={{ textTransform: "none" }}>{t("bidders")}</span>
        </Tooltip>
      ),
      width: 340,
      dataIndex: "siteLocations",
      render: (siteLocations, record) => {
        if (
          record.siteName === "City Total" ||
          record.siteName === "Site Sub-Total"
        ) {
          return "";
        }

        if (
          siteLocations &&
          siteLocations.length > 0 &&
          siteLocations.materialName !== ""
        ) {
          return (
            <div
              style={{ display: "flex", flexDirection: "column", gap: "10px" }}
            >
              {siteLocations.map((site, index) => {
                return (
                  <div key={index}>
                    <Select
                      style={{ width: "100%" }}
                      mode="multiple"
                      maxTagCount="responsive"
                      allowClear
                      showSearch
                      placeholder="Please select"
                      optionFilterProp="children"
                      defaultValue={
                        site?.vendors?.some(
                          (vendor) => vendor.is_selected_vendor
                        )
                          ? site?.vendors
                              ?.filter((vendor) => vendor.is_selected_vendor)
                              ?.map((vendor) => vendor.id)
                          : site?.vendors?.map((vendor) => vendor.id)
                      }
                      onChange={(value) =>
                        handleVendorChange(
                          value,
                          site.cityName,
                          site.siteId,
                          site.matInd
                        )
                      }
                    >
                      {site?.vendors?.map((vendor) => (
                        <Select.Option key={vendor.id} value={vendor.id}>
                          {vendor.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </div>
                );
              })}
            </div>
          );
        }

        return null;
      },
    },
    {
      title: "Remark",
      dataIndex: "siteLocations",
      align: "left",
      render: (siteLocations, record) => {
        if (
          record.siteName !== "City Total" ||
          record.siteName !== "Site Sub-Total"
        ) {
          return (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "22px",
                marginRight: "40px",
              }}
            >
              {siteLocations.map((site, index) => {
                return (
                  <div key={index} className="lblvalue" style={{textTransform:'none'}}>
                    {site.remark || ""}
                  </div>
                );
              })}
            </div>
          );
        }
      },
    },
  ];

  if (cityLength > 1) {
    columns.splice(1, 0, {
      title: "City",
      dataIndex: "cityName",
      key: "cityName",
      width: 110,
      render: (text, record, index) => {
        if (index === 0 || record.cityName !== tableData[index - 1].cityName) {
          return <div className="lblvalue">{text}</div>;
        } else {
          return <div className="lblvalue" />;
        }
      },
    });
  }

  const theadPR = <Table columns={columns} />;

  useEffect(() => {}, [tableData]);
  const getVendorIds = (siteIndex) => {
    const vendors = siteIndex?.vendors || [];
    if (Array.isArray(siteIndex?.vendor) && siteIndex.vendor.length > 0) {
      return siteIndex.vendor;
    }

    const hasSelectedVendor = vendors.some((v) => v.is_selected_vendor);

    if (hasSelectedVendor) {
      return vendors.filter((v) => v.is_selected_vendor).map((v) => v.id);
    } else {
      return vendors.map((v) => v.id);
    }
  };
  const createPayload = (tableData) => {
    const payload = {
      rfq_master: masterId,
      rfq_site_details: [],
    };

    const siteGroupedData = {};

    tableData.forEach((site) => {
      if (!site.siteLocations || site.siteName === "Site Sub-Total") return;

      if (site.siteData && Array.isArray(site.siteData)) {
        site.siteData.forEach((location) => {
          const siteIndex = site.siteLocations.find(
            (siteLocation) =>
              siteLocation.siteId === location.site_name &&
              siteLocation.materialName === location.material_type_names
          );

          if (siteIndex) {
            const siteName = location.site_id;

            if (!siteGroupedData[siteName]) {
              siteGroupedData[siteName] = {
                purchase_requisition_site_name: siteName,
                rfq_material_details: [],
              };
            }
            let material_total_quantity;

            if (siteIndex.purchase_master_ids.length > 1) {
              if (siteIndex.uom === "Cubic Meter") {
                material_total_quantity = location.pr_total_quantity;
              } else if (siteIndex.unit_measurement_name === "MT") {
                material_total_quantity =
                  location.pr_total_quantity_by_kg / 1000;
              } else if (siteIndex.unit_measurement_name === "Bag") {
                material_total_quantity = location.pr_total_quantity_by_kg / 50;
              } else if (siteIndex.unit_measurement_name === "Cubic Meter") {
                material_total_quantity = location.pr_total_quantity;
              } else {
                material_total_quantity = location.pr_total_quantity;
              }
            } else {
              if (siteIndex.uom === "Cubic Meter") {
                material_total_quantity = location.pr_total_quantity;
              } else if (siteIndex.unit_measurement_name === "MT") {
                material_total_quantity = location.pr_total_quantity;
              } else if (siteIndex.unit_measurement_name === "Bag") {
                material_total_quantity = location.pr_total_quantity;
              } else {
                material_total_quantity = location.pr_total_quantity;
              }
            }

            siteGroupedData[siteName].rfq_material_details.push({
              id: location.rfqActualId || null,
              material_total_quantity: material_total_quantity,
              material_total_quantity_by_kg:
                location.pr_total_quantity_by_kg || 0,
              amount:
                location.material_type_uom_name === "Cubic Meter"
                  ? location.pr_total_quantity *
                    location.estimated_material_unit_price
                  : location.pr_total_quantity_by_kg *
                      location.estimated_material_unit_price || 0,
              purchase_requisition_material:
                location.purchase_requisition_material_id,
              unit_of_measurement:
                siteIndex.purchase_master_ids.length > 1
                  ? location.material_type_uom_name === "Cubic Meter"
                    ? 4
                    : siteIndex.unit_measurement
                  : siteIndex.unit_measurement,
              vendor: getVendorIds(siteIndex),
            });
          } else {
            console.warn(
              "No matching siteIndex found for location:",
              location.site_name
            );
          }
        });
      } else {
        console.warn("No siteData found for site:", site);
      }
    });

    payload.rfq_site_details = Object.values(siteGroupedData);

    return payload;
  };

  const createPayload2 = (tableData) => {
    const payload = {
      rfq_master: masterId,
      rfq_site_details: [],
    };

    const siteGroupedData = {};

    tableData.forEach((site) => {
      if (!site.siteLocations || site.siteName === "Site Sub-Total") return;

      if (site.siteData && Array.isArray(site.siteData)) {
        site.siteData.forEach((location) => {
          const siteIndex = site.siteLocations.find(
            (siteLocation) =>
              siteLocation.siteId === location.site_name &&
              siteLocation.materialName === location.material_type_names
          );

          if (siteIndex) {
            const siteName = location.site_id;

            if (!siteGroupedData[siteName]) {
              siteGroupedData[siteName] = {
                purchase_requisition_site_name: siteName,
                rfq_material_details: [],
              };
            }
            let material_total_quantity;

            if (siteIndex.purchase_master_ids.length > 1) {
              if (siteIndex.uom === "Cubic Meter") {
                material_total_quantity = location.pr_total_quantity;
              } else if (siteIndex.unit_measurement_name === "MT") {
                material_total_quantity =
                  location.pr_total_quantity_by_kg / 1000;
              } else if (siteIndex.unit_measurement_name === "Bag") {
                material_total_quantity = location.pr_total_quantity_by_kg / 50;
              } else {
                material_total_quantity = location.pr_total_quantity;
              }
            } else {
              if (siteIndex.uom === "Cubic Meter") {
                material_total_quantity = location.pr_total_quantity;
              } else if (siteIndex.unit_measurement_name === "MT") {
                material_total_quantity = location.pr_total_quantity;
              } else if (siteIndex.unit_measurement_name === "Bag") {
                material_total_quantity = location.pr_total_quantity;
              } else {
                material_total_quantity = location.pr_total_quantity;
              }
            }

            siteGroupedData[siteName].rfq_material_details.push({
              id: location.rfqActualId || null,
              material_total_quantity: material_total_quantity,
              material_total_quantity_by_kg:
                location.pr_total_quantity_by_kg || 0,
              amount:
                location.material_type_uom_name === "Cubic Meter"
                  ? location.pr_total_quantity *
                    location.estimated_material_unit_price
                  : location.pr_total_quantity_by_kg *
                      location.estimated_material_unit_price || 0,
              purchase_requisition_material:
                location.purchase_requisition_material_id,
              unit_of_measurement:
                siteIndex.purchase_master_ids.length > 1
                  ? location.material_type_uom_name === "Cubic Meter"
                    ? 4
                    : siteIndex.unit_measurement
                  : siteIndex.unit_measurement,
              vendor: getVendorIds(siteIndex),
            });
          } else {
            console.warn(
              "No matching siteIndex found for location:",
              location.site_name
            );
          }
        });
      } else {
        console.warn("No siteData found for site:", site);
      }
    });

    payload.rfq_site_details = Object.values(siteGroupedData);

    return payload;
  };

  const handleSubmit = async () => {
    try {
      setBtnLoading(true);
      const hasEmptyVendor = tableData.some((item) =>
        item.siteData?.some(
          (material) =>
            Array.isArray(material.vendor) && material.vendor.length === 0
        )
      );

      if (hasEmptyVendor) {
        ErrorNotificationMsg("Select At Least One Vendor");
        setBtnLoading(false);
        return;
      }
      const payload = createPayload(tableData);
      const payload2 = createPayload2(tableData);

      let response;
      if (rfqMaterialDetailsID === false) {
        response = await postRequest(`rfq-material-details/`, payload2);
        if (response.data.message) {
          navigate(`/request-for-quotation/history`);
          SuccessNotificationMsg(response.data.message);

          setBtnLoading(false);
        } else {
          ErrorNotificationMsg(response.data.message);
          setBtnLoading(false);
        }
      } else {
        response = await patchRequest(
          `rfq-material-details/${masterId}/`,
          payload
        );

        if (response.data.message) {
          SuccessNotificationMsg(response.data.message);
          navigate(`/request-for-quotation/history`);
        }
      }

      if (response.data.success && rfqMaterialDetailsID === false) {
        setBtnLoading(true);
        const updateTableData = (state) => {
          if (!Array.isArray(state)) {
            return;
          }
          let rfqPresent = null;
          const uniqueMasterIds = new Set();
          state?.forEach((city) => {
            city.city_wise_pr?.forEach((cityDetail) => {
              cityDetail.site_wise_details?.forEach((site) => {
                site.material_wise_details?.forEach((material) => {
                  if (material.purchase_requisition_master_id) {
                    uniqueMasterIds.add(
                      material.purchase_requisition_master_id
                    );
                  }
                });
              });
            });
          });

          const hasMultipleMasterIds = uniqueMasterIds.size > 1;

          const tableData = [];
          const length = state[0].city_wise_pr.length;
          setCityLength(length);

          state.forEach((prObject, prIndex) => {
            prObject.city_wise_pr.forEach((city, cityIndex) => {
              const cityRowSpan = city.site_wise_details.length;
              let cityTotalQuantity = 0;
              let cityTotalQuantityInKg = 0;
              let cityTotal = 0;

              city.site_wise_details.forEach((site, siteIndex) => {
                let siteTotalQuantity = 0;
                let siteTotalQuantityInKg = 0;
                let siteMaterialTotalAmount = 0;

                let siteMaterialTotalAmountWithKG = 0;

                const groupedData = {};
                site.material_wise_details.forEach((material) => {
                  const rfqId =
                    material.purchase_requisition_material_id || null;

                  const rfqActualId = material.rfq_material_id || null;

                  rfqPresent = material.rfq_material_id;

                  if (!groupedData[rfqId]) {
                    groupedData[rfqId] = {
                      rfq_material_id: rfqId,
                      site_id: site.site_id,
                      rfqActualId: rfqActualId,
                      site_name: site.site_name,
                      material_type_names: new Set([
                        material.material_type_name,
                      ]),
                      material_type_sub_category:
                        material.material_type_sub_category,
                      pr_total_quantity: material.pr_total_quantity,
                      pr_total_quantity_by_kg: material.pr_total_quantity_by_kg,
                      estimated_material_unit_price:
                        material.estimated_material_unit_price,
                      pr_total_amount: material.pr_total_amount,
                      material_type_uom: material.material_type_uom,
                      material_type_uom_name: hasMultipleMasterIds
                        ? material.material_type_uom_name
                        : material.preferred_unit_of_measurement,
                      preferred_unit_of_measurement:
                        material.preferred_unit_of_measurement,
                      preferred_unit_of_measurement_id:
                        material.preferred_unit_of_measurement_id,
                      purchase_requisition_material_id:
                        material.purchase_requisition_material_id,
                    };
                  } else {
                    groupedData[rfqId].material_type_names.add(
                      material.material_type_name
                    );
                    groupedData[rfqId].pr_total_quantity +=
                      material.pr_total_quantity;
                    groupedData[rfqId].pr_total_amount +=
                      material.pr_total_amount;
                  }
                });
                const result = Object.values(groupedData).map((item) => ({
                  ...item,
                  material_type_names: Array.from(
                    item.material_type_names
                  ).join(", "),
                }));
                const materialGroups = site.material_wise_details.reduce(
                  (acc, material, index) => {
                    if (material.purchase_requisition_master_id) {
                      uniqueMasterIds.add(
                        material.purchase_requisition_master_id
                      );
                    }

                    const {
                      material_type_name,
                      material_type_uom_name,
                      preferred_unit_of_measurement,
                      pr_total_quantity,
                      pr_total_quantity_by_kg,
                      estimated_material_unit_price,
                      pr_total_amount,
                      purchase_requisition_master_id,
                      actual_quantity,
                      rfq_material_id,
                      purchase_requisition_material_id,
                      preferred_unit_of_measurement_id,
                      material_type_uom,
                      remark,
                      vendors,
                    } = material;

                    if (!acc[material_type_name]) {
                      acc[material_type_name] = {
                        material_type_name,
                        preferred_unit_of_measurement,
                        material_type_uom_name,
                        total_quantity: 0,
                        actual_quantity: 0,
                        total_quantity_by_kg: 0,
                        total_amount: 0,
                        estimated_material_unit_price,
                        purchase_requisition_master_ids: new Set(),
                        rfq_material_id,
                        purchase_requisition_material_id,
                        preferred_unit_of_measurement_id,
                        material_type_uom,
                        remark,
                        vendors,
                        siteIndex,
                        cityIndex,
                        index,
                      };
                    }

                    let convertedQuantity = pr_total_quantity;
                    if (
                      material_type_uom_name !==
                        preferred_unit_of_measurement &&
                      hasMultipleMasterIds &&
                      rfq_material_id === null
                    ) {
                      if (
                        material_type_uom_name === "Bag" &&
                        preferred_unit_of_measurement === "KG"
                      ) {
                        convertedQuantity = pr_total_quantity * 50;
                      } else if (
                        material_type_uom_name === "Bag" &&
                        preferred_unit_of_measurement === "MT"
                      ) {
                        convertedQuantity = (pr_total_quantity * 50) / 1000;
                      } else if (
                        material_type_uom_name === "KG" &&
                        preferred_unit_of_measurement === "MT"
                      ) {
                        convertedQuantity = pr_total_quantity / 1000;
                      } else if (
                        material_type_uom_name === "MT" &&
                        preferred_unit_of_measurement === "KG"
                      ) {
                        convertedQuantity = pr_total_quantity * 1000;
                      }
                    } else {
                      if (
                        material_type_uom_name === "Bag" &&
                        preferred_unit_of_measurement === "KG"
                      ) {
                        convertedQuantity = pr_total_quantity;
                      } else if (
                        material_type_uom_name === "Bag" &&
                        preferred_unit_of_measurement === "MT"
                      ) {
                        convertedQuantity = pr_total_quantity;
                      } else if (
                        material_type_uom_name === "KG" &&
                        preferred_unit_of_measurement === "MT"
                      ) {
                        convertedQuantity = pr_total_quantity;
                      } else if (
                        material_type_uom_name === "MT" &&
                        preferred_unit_of_measurement === "KG"
                      ) {
                        convertedQuantity = pr_total_quantity;
                      }
                    }

                    acc[material_type_name].total_quantity += convertedQuantity;
                    acc[material_type_name].actual_quantity +=
                      convertedQuantity;
                    acc[material_type_name].total_quantity_by_kg +=
                      pr_total_quantity_by_kg;
                    acc[material_type_name].total_amount += pr_total_amount;

                    if (purchase_requisition_master_id) {
                      acc[
                        material_type_name
                      ].purchase_requisition_master_ids.add(
                        purchase_requisition_master_id
                      );
                    }

                    return acc;
                  },
                  {}
                );
                let groupedMaterials = Object.values(materialGroups).map(
                  (material) => {
                    let unitMeasurement = "MT";
                    let unitMeasurementId = 1;

                    if (
                      material.total_quantity_by_kg / 1000 ===
                      material.total_quantity
                    ) {
                      unitMeasurement = material.preferred_unit_of_measurement;
                      unitMeasurementId =
                        material.preferred_unit_of_measurement_id;
                    } else if (
                      material.total_quantity_by_kg / 50 ===
                      material.total_quantity
                    ) {
                      unitMeasurement = material.material_type_uom_name;
                      unitMeasurementId = material.material_type_uom;
                    }
                    if (
                      Array.from(material.purchase_requisition_master_ids)
                        .length > 1 &&
                      material.rfq_material_id === null
                    ) {
                      material.material_type_uom = unitMeasurementId;
                      material.material_type_uom_name = unitMeasurement;
                      return {
                        ...material,
                        purchase_requisition_master_ids: Array.from(
                          material.purchase_requisition_master_ids
                        ),
                      };
                    } else {
                      return {
                        ...material,
                        purchase_requisition_master_ids: Array.from(
                          material.purchase_requisition_master_ids
                        ),
                      };
                    }
                  }
                );
                groupedMaterials = Object.values(materialGroups);
                groupedMaterials.forEach((material) => {
                  const {
                    material_type_name,
                    preferred_unit_of_measurement,
                    total_quantity,
                    total_quantity_by_kg,
                  } = material;

                  siteTotalQuantity += total_quantity;
                  siteMaterialTotalAmount += material.total_amount;
                  siteTotalQuantityInKg += total_quantity_by_kg;
                  siteMaterialTotalAmountWithKG +=
                    total_quantity_by_kg * total_quantity;
                });

                site.site_total_quantity = siteTotalQuantity;
                cityTotalQuantity += siteTotalQuantity;
                cityTotalQuantityInKg += siteTotalQuantityInKg;
                cityTotal += siteMaterialTotalAmount;

                tableData.push({
                  key: `${prIndex}-${cityIndex}-${siteIndex}`,
                  srNo:
                    length > 1
                      ? siteIndex === 0
                        ? cityIndex + 1
                        : null
                      : siteIndex + 1,
                  cityName: siteIndex === 0 ? city.city_name : "",
                  cityName1: city.city_name,

                  cityRowSpan: siteIndex === 0 ? cityRowSpan : 0,
                  siteName: site.site_name,
                  siteName1: site.site_name,
                  siteData: result,
                  siteLocations: groupedMaterials.map((material, ind) => {
                    return {
                      vendors: material?.vendors,
                      cityName: city.city_name,
                      cityIndex: material.cityIndex,
                      siteIndex: material.cityIndex,
                      siteId: site.site_name,
                      matInd: ind,
                      materialName: material.material_type_name,
                      quantity: material.total_quantity,
                      actual_quantity: material.actual_quantity,
                      quantity_by_kg:
                        material.total_quantity_by_kg.toLocaleString("en-IN", {
                          maximumFractionDigits: 0,
                        }),
                      remark: material.remark,
                      uom: material.preferred_unit_of_measurement,
                      uom_pref: material.preferred_unit_of_measurement_id,
                      subCategory: material.material_type_sub_category,
                      estimatedPrice: material.estimated_material_unit_price,
                      materialTotal: material.total_amount,
                      unit_measurement: material.material_type_uom,
                      unit_measurement_id: material.material_type_uom,
                      unit_measurement_name: material.material_type_uom_name,
                      purchase_master_ids: [
                        ...material.purchase_requisition_master_ids,
                      ],
                      purchase_requisition_material_id:
                        material.purchase_requisition_material_id,
                      rfq_material_idd: material.rfq_material_id,
                    };
                  }),
                  totalAmount: (
                    <Input
                      disabled
                      value={`\u20B9 ${siteMaterialTotalAmount || 0}`}
                      className="site-subtotal"
                    />
                  ),
                });

                tableData.push({
                  key: `${prIndex}-${cityIndex}-${siteIndex}-SiteSubTotal`,
                  siteName: "Site Sub-Total",
                  siteLocations: [
                    {
                      totalQuantity: siteMaterialTotalAmount,
                      materialName: "",
                      quantity: "",
                      quantity_by_kg: "",
                      subCategory: "",
                      siteIndex,
                      cityId: city.city_id,
                      siteId: site.site_id,
                    },
                  ],
                  totalAmount: (
                    <Input
                      disabled
                      value={`\u20B9 ${siteMaterialTotalAmount || 0}`}
                      className="site-subtotal"
                    />
                  ),
                  siteTotalQuantity: (
                    <Input
                      disabled
                      value={
                        siteTotalQuantity?.toLocaleString("en-IN", {
                          maximumFractionDigits: 0,
                        }) || 0
                      }
                      className="site-total-quantity"
                      readOnly
                    />
                  ),
                });

                if (
                  length > 1 &&
                  siteIndex === city.site_wise_details.length - 1
                ) {
                  tableData.push({
                    key: `${prIndex}-${cityIndex}-${siteIndex}-CityTotal`,
                    siteName: "City Total",
                    siteLocations: [
                      {
                        materialName: "",
                        cityTotal: cityTotal,
                        quantity: "",
                        quantity_by_kg: "",
                        subCategory: "",
                        siteIndex,
                        cityId: city.city_id,
                        siteId: site.site_id,
                      },
                    ],
                    totalAmount: cityTotal,
                    cityTotalQuantity: (
                      <Input
                        disabled
                        value={cityTotalQuantity || 0}
                        className="city-total-quantity"
                        readOnly
                      />
                    ),
                  });
                }
              });

              city.city_total_quantity = cityTotal;
            });
          });

          return tableData;
        };
        const createPayload = (tableData, oldTableData) => {
          const payload = {
            rfq_master: masterId,
            rfq_site_details: [],
          };

          const siteGroupedData = {};

          tableData.forEach((site) => {
            if (!site.siteLocations || site.siteName === "Site Sub-Total")
              return;

            if (site.siteData && Array.isArray(site.siteData)) {
              site.siteData.forEach((location) => {
                const rfqID = tableData
                  .flatMap((item) => item.siteLocations)
                  .find(
                    (siteLocation) =>
                      siteLocation.siteId === location.site_name &&
                      siteLocation.materialName === location.material_type_names
                  )?.rfq_material_idd;

                const siteIndex = site.siteLocations.find(
                  (siteLocation) =>
                    siteLocation.siteId === location.site_name &&
                    siteLocation.materialName === location.material_type_names
                );

                const siteVendors = oldTableData
                  .flatMap((item) => item.siteLocations)
                  .find(
                    (siteLocation) =>
                      siteLocation.siteId === location.site_name &&
                      siteLocation.materialName === location.material_type_names
                  )?.vendor;

                if (siteIndex) {
                  const siteName = location.site_id;

                  if (!siteGroupedData[siteName]) {
                    siteGroupedData[siteName] = {
                      purchase_requisition_site_name: siteName,
                      rfq_material_details: [],
                    };
                  }
                  let material_total_quantity;

                  if (siteIndex.purchase_master_ids.length > 1) {
                    if (siteIndex.uom === "Cubic Meter") {
                      material_total_quantity = location.pr_total_quantity;
                    } else if (siteIndex.unit_measurement_name === "MT") {
                      material_total_quantity =
                        location.pr_total_quantity_by_kg / 1000;
                    } else if (siteIndex.unit_measurement_name === "Bag") {
                      material_total_quantity =
                        location.pr_total_quantity_by_kg / 50;
                    } else {
                      material_total_quantity = location.pr_total_quantity;
                    }
                  } else {
                    if (siteIndex.uom === "Cubic Meter") {
                      material_total_quantity = location.pr_total_quantity;
                    } else if (siteIndex.unit_measurement_name === "MT") {
                      material_total_quantity = location.pr_total_quantity;
                    } else if (siteIndex.unit_measurement_name === "Bag") {
                      material_total_quantity = location.pr_total_quantity;
                    } else {
                      material_total_quantity = location.pr_total_quantity;
                    }
                  }

                  siteGroupedData[siteName].rfq_material_details.push({
                    id: location.rfqActualId || null,
                    material_total_quantity: material_total_quantity,
                    material_total_quantity_by_kg:
                      location.pr_total_quantity_by_kg || 0,
                    amount:
                      location.material_type_uom_name === "Cubic Meter"
                        ? location.estimated_material_unit_price *
                          location.pr_total_quantity
                        : location.pr_total_amount || 0,
                    purchase_requisition_material:
                      location.purchase_requisition_material_id,
                    unit_of_measurement:
                      siteIndex.purchase_master_ids.length > 1
                        ? location.material_type_uom_name === "Cubic Meter"
                          ? 4
                          : siteIndex.unit_measurement
                        : siteIndex.unit_measurement,
                    vendor:
                      siteVendors !== undefined
                        ? siteVendors
                        : siteIndex?.vendors.map((i) => i.id) || [],
                  });
                } else {
                  console.warn(
                    "No matching siteIndex found for location:",
                    location.site_name
                  );
                }
              });
            } else {
              console.warn("No siteData found for site:", site);
            }
          });

          payload.rfq_site_details = Object.values(siteGroupedData);

          return payload;
        };
        const updateAndCallAPI = async () => {
          const res = updateTableData(
            response?.data?.data?.pr_city_wise_by_pr_number
          );

          const newPayload = createPayload(res, tableData);
          try {
            response = await patchRequest(
              `rfq-material-details/${masterId}/`,
              newPayload
            );

            if (response.data.message) {
              navigate(`/request-for-quotation/history`);
              SuccessNotificationMsg(response.data.message);

              setBtnLoading(false);
            } else {
              ErrorNotificationMsg(response.data.message);
              setBtnLoading(false);
            }
          } catch (error) {
            console.error("Error calling API:", error);
            setBtnLoading(false);
          }
        };
      }
    } catch (error) {
      setBtnLoading(false);
    }
  };
  const handleDraft = async () => {
    try {
      setBtnLoading2(true);

      const payload = {
        company: state.company,
        category_tree: state.category_tree,
        total_amount: state.total_amount,
        purchase_requisition_details: state.purchase_requisition_details.map(
          (detail) => {
            return {
              material_type: detail.material_type,
              unit_of_measurement: detail.unit_of_measurement,
              total_quantity: detail.total_quantity,

              site_wise: detail.site_wise.map((site) => {
                return {
                  site_name: site.site_name,
                  quantity: site.quantity,
                };
              }),
            };
          }
        ),
      };

      let response;
      response = await postRequest(
        "purchase-requisition/draft-purchase-requisition/",
        payload
      );

      if (response.data.success) {
        SuccessNotificationMsg(
          CompanyID === null
            ? t("purchase_requisition_draft_successfully")
            : t("purchase_requisition_draft_updated_successfully")
        );

        setState(initialState);
        navigate("/purchase-requisition-history");
        setBtnLoading2(false);
      }
    } catch (error) {
      setBtnLoading2(false);
    }
  };

  return (
    <Spin spinning={apiLoading}>
      {
        <>
          <div className="tablewrp">
            {response?.pr_city_wise_by_pr_number?.map((prObject, prIndex) => (
              <>
                <Table
                  columns={columns}
                  dataSource={tableData.filter((row) =>
                    row.key.startsWith(`${prIndex}`)
                  )}
                  scroll={{
                    x: "auto",
                  }}
                  pagination={false}
                  rowKey="key"
                />
              </>
            ))}
          </div>
          <div
            className="FormFooter bidftr"
            style={{
              padding: "16px  ",
              paddingBottom: "0",
              margin: "0",
              marginBottom: "40px",
            }}
          >
            <ButtonField
              className="SaveGradiantBtn"
              type="primary"
              htmlType="Previous"
              label="Previous"
              onClick={() =>
                navigate(`/request-for-quotation/add-rfq/${responseId}`)
              }
            />
            <ButtonField
              className="SaveGradiantBtn"
              type="primary"
              htmlType="submit"
              label="Save & Send RFQ For Approval"
              onClick={() => handleSubmit(state.rfqId)}
              loading={btnLoading}
            />
          </div>
        </>
      }
    </Spin>
  );
};

CityWiseView.propTypes = {
  response: PropTypes.func,
  uomList: PropTypes.func,
};

export default CityWiseView;
